import { requestBuilder } from '../../../http/RequestBuilder';
import type { User } from '../../../user/types/User';
import { type KycFlowSourceEnum } from '../../components/kyc/Kyc';
import type { Disclosure } from '../../types/BankAccount';
import { type EmploymentType, type IndustryType } from '../../types/Edd';

export interface RunKYCVerifyBody {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    ssn: string;
    dateOfBirth: string;
    line1: string;
    line2?: string;
    city: string;
    postalCode: string;
    state?: string;
    countryCode: string;
    disclosures: Disclosure[];
    neuroSiteId: string;
    neuroUserId: string;
    iovationBlackboxId: string;
    socureDeviceId: string;
    employmentType?: EmploymentType;
    occupationIndustry?: IndustryType;
    kycFlowSource?: KycFlowSourceEnum;
}

interface RunKYCVerifyBodyURLParams {
    userId: string;
}

export const useRunKYCVerify = requestBuilder.mutation<
    User,
    RunKYCVerifyBody,
    RunKYCVerifyBodyURLParams
>({
    endpoint: ({ userId }) => `/api/user/${userId}/kyc/verify`,
    method: 'POST',
});

export default useRunKYCVerify;
